import { render } from "./SelectImageModal.vue?vue&type=template&id=2dee5be8&scoped=true&ts=true"
import script from "./SelectImageModal.vue?vue&type=script&lang=ts"
export * from "./SelectImageModal.vue?vue&type=script&lang=ts"

import "./SelectImageModal.vue?vue&type=style&index=0&id=2dee5be8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dee5be8"]])

export default __exports__